
function Menu() {
    const doc = document.getElementsByClassName("b-width")[0];
    doc.classList.toggle("show");
}

export default Menu;